

import React from "react";

export const UtensilsCrossed4 = ({ className ,state="defualt" }) => {
  return (
<svg
className={`${className}`}
fill="none"
height="24"
viewBox="0 0 24 24"
width="24"
xmlns="http://www.w3.org/2000/svg"
>
<path
  d="M15.9997 2L13.6997 4.3C13.15 4.86079 12.8421 5.61474 12.8421 6.4C12.8421 7.18526 13.15 7.93921 13.6997 8.5L15.4997 10.3C16.0605 10.8497 16.8144 11.1576 17.5997 11.1576C18.3849 11.1576 19.1389 10.8497 19.6997 10.3L21.9997 8M14.9997 15L3.29967 3.3C2.90056 3.69105 2.58348 4.15782 2.36702 4.67295C2.15056 5.18809 2.03906 5.74123 2.03906 6.3C2.03906 6.85877 2.15056 7.41191 2.36702 7.92705C2.58348 8.44218 2.90056 8.90895 3.29967 9.3L10.5997 16.6C11.2997 17.3 12.5997 17.3 13.3997 16.6L14.9997 15ZM14.9997 15L21.9997 22M2.09967 21.8L8.49967 15.5M18.9997 5L11.9997 12"
  stroke="black"
  strokeLinecap="round"
  strokeLinejoin="round"
  strokeWidth="2"
/>
</svg>

  );
};


    // <svg
    //   className={`utensils-crossed-4 ${className}`}
    //   fill="none"
    //   height="16"
    //   viewBox="0 0 16 16"
    //   width="16"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <g className="g" clipPath="url(#clip0_726_281)" opacity="0.5">
    //     <path
    //       className="path"
    //       d="M10.6665 1.33331L9.13312 2.86665C8.76666 3.2405 8.5614 3.74314 8.5614 4.26665C8.5614 4.79015 8.76666 5.29279 9.13312 5.66665L10.3331 6.86665C10.707 7.2331 11.2096 7.43836 11.7331 7.43836C12.2566 7.43836 12.7593 7.2331 13.1331 6.86665L14.6665 5.33331M9.99978 9.99998L2.19978 2.19998C1.9337 2.46068 1.72232 2.77186 1.57801 3.11528C1.43371 3.4587 1.35938 3.82747 1.35938 4.19998C1.35938 4.57249 1.43371 4.94126 1.57801 5.28468C1.72232 5.6281 1.9337 5.93928 2.19978 6.19998L7.06645 11.0666C7.53312 11.5333 8.39978 11.5333 8.93312 11.0666L9.99978 9.99998ZM9.99978 9.99998L14.6665 14.6666M1.39978 14.5333L5.66645 10.3333M12.6665 3.33331L7.99978 7.99998"
    //       stroke={state=="active"?"white":"black"}
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //       strokeWidth="1.33333"
    //     />
    //   </g>

    //   <defs className="defs">
    //     <clipPath className="clip-path" id="clip0_726_281">
    //       <rect className="rect" fill="white" height="16" width="16" />
    //     </clipPath>
    //   </defs>
    // </svg>

{/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
   className={`utensils-crossed-4 ${className}`}
>
<g id="utensils-crossed" clip-path="url(#clip0_1395_2526)">
<path id="Vector" d="M13.3333 1.6665L11.4166 3.58317C10.9586 4.05049 10.702 4.67879 10.702 5.33317C10.702 5.98755 10.9586 6.61585 11.4166 7.08317L12.9166 8.58317C13.384 9.04124 14.0123 9.29781 14.6666 9.29781C15.321 9.29781 15.9493 9.04124 16.4166 8.58317L18.3333 6.6665M12.5 12.4998L2.74997 2.74984C2.41737 3.07572 2.15315 3.46469 1.97276 3.89396C1.79238 4.32324 1.69946 4.7842 1.69946 5.24984C1.69946 5.71548 1.79238 6.17643 1.97276 6.60571C2.15315 7.03499 2.41737 7.42396 2.74997 7.74984L8.83331 13.8332C9.41664 14.4165 10.5 14.4165 11.1666 13.8332L12.5 12.4998ZM12.5 12.4998L18.3333 18.3332M1.74997 18.1665L7.08331 12.9165M15.8333 4.1665L9.99997 9.99984" 
     stroke={state=="active"?"white":"black"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_1395_2526">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg> */}
